import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PpbSharedModule } from 'projects/ppb-shared-library/src/lib/ppb-shared.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { PseiNgCustomModule } from '../../../../projects/ppb-shared-library/src/lib/psei-ng-custom.module';
import { PpbShareModule } from '../shared/ppb-share.module';
import { PpbInvitationComponent } from './ppb-invitation.component';
import { PpbInvitationRoutingModule } from './ppb-terms-routing.module';


@NgModule({
  declarations: [PpbInvitationComponent],
  imports: [
    CommonModule,
    SharedModule,
    PseiNgCustomModule,
    RouterModule,
    PpbSharedModule,
    PpbShareModule,
    PpbInvitationRoutingModule
  ]
})
export class PpbInvitationModule {}
